export const SURVEY_STARTED_AT_KEY = "surveyStartedAt";
export const SURVEY_ORIGIN_KEY = "surveyOrigem";
export const SURVEY_PRIVACY_ACCEPTED_KEY = "surveyPrivacyAccepted";
export const SURVEY_PRIVACY_ACCEPTED_AT_KEY = "surveyPrivacyAcceptedAt";

export const getOrigemFromSearch = (search = "") => {
  const params = new URLSearchParams(search);
  const origem = params.get("origem");
  return origem ? origem.trim() : "";
};

export const captureSurveyOrigem = (search = "") => {
  const origem = getOrigemFromSearch(search);
  if (origem) {
    sessionStorage.setItem(SURVEY_ORIGIN_KEY, origem);
  }
  return origem;
};

export const markSurveyStarted = (search, { privacyAccepted = false } = {}) => {
  const querySearch =
    search ??
    (typeof window !== "undefined" ? window.location.search : "");
  const startedAt = new Date().toISOString();

  sessionStorage.setItem(SURVEY_STARTED_AT_KEY, startedAt);
  captureSurveyOrigem(querySearch);

  if (privacyAccepted) {
    sessionStorage.setItem(SURVEY_PRIVACY_ACCEPTED_KEY, "true");
    sessionStorage.setItem(SURVEY_PRIVACY_ACCEPTED_AT_KEY, startedAt);
  } else {
    sessionStorage.removeItem(SURVEY_PRIVACY_ACCEPTED_KEY);
    sessionStorage.removeItem(SURVEY_PRIVACY_ACCEPTED_AT_KEY);
  }
};

export const getSurveyStartedAt = () =>
  sessionStorage.getItem(SURVEY_STARTED_AT_KEY);

export const getSurveyOrigem = () =>
  sessionStorage.getItem(SURVEY_ORIGIN_KEY) ?? "";

export const getSurveyPrivacyAccepted = () =>
  sessionStorage.getItem(SURVEY_PRIVACY_ACCEPTED_KEY) === "true";

export const getSurveyPrivacyAcceptedAt = () =>
  sessionStorage.getItem(SURVEY_PRIVACY_ACCEPTED_AT_KEY);